import { CommonModule } from '@angular/common';
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { LittleBarsLoaderComponent } from '@upassignations/core';

@Component({
  selector: 'lib-metadata-panel',
  imports: [CommonModule, LittleBarsLoaderComponent],
  templateUrl: './metadata-panel.component.html',
  styleUrl: './metadata-panel.component.scss',
})
export class MetadataPanelComponent {
  @Input() loadingMetadata = false;
  @Input() metadata: { key: string; value: any }[] = [];
  @Output() closeSidePanel = new EventEmitter<void>();

  dropdownIsActive = false;

  close(): void {
    this.closeSidePanel.emit();
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  toggleChevron(): void {
    this.dropdownIsActive = !this.dropdownIsActive;
  }
}
